//client\src\views\Interactive_parts\OfflinePOILayer.js

import React, { useState, useCallback, useEffect } from 'react';
import OfflinePOIMarker from '../../components/OfflinePOIMarker';
import OfflineEditPOI from '../../components/OfflineEditPOI';

function OfflinePOILayer({
  pois,
  foundPOIs,
  showFound,
  customCategories,
  customTypes,
  hoveredPoiId,
  hoveredType,
  setHoveredPoiId,
  visibleTypes,
  visibleCategories,
  showAllPoiLabels,
  typeColours,
  onCategoryUpdate,
  canEdit,
  mapId,
  user,
  mapOwnerId,
  onToggleFound,
  selectedPoiId,
  setSelectedPoiId,
  hideSidebarHover,
  onOpenEditModal = () => {},
  onCloseEditModal = () => {},
  onOpenInfoModal = () => {},
  onCloseInfoModal = () => {},
}) {
  const [openModalPoiId, setOpenModalPoiId] = useState(null);
  const [modalEditingPoiId, setModalEditingPoiId] = useState(null);

  const foundPOIsSafe = Array.isArray(foundPOIs) ? foundPOIs : [];

  const [livePois, setLivePois] = useState(pois);

  useEffect(() => {
    setLivePois(pois);
  }, [pois]);

  const filteredPOIs = livePois.filter(poi => {
    const categoryVal = poi.category_id ?? poi.category;
    const typeVal = poi.type_id ?? poi.type;
    const typePass = visibleTypes.has(typeVal);
    const catPass = visibleCategories.has(categoryVal);
    return poi && categoryVal && typeVal && typePass && catPass;
  });

  const handleOpenModal = useCallback((poiId) => {
    setOpenModalPoiId(poiId);
    onOpenInfoModal();
  }, [onOpenInfoModal]);

  const handleCloseModal = useCallback(() => {
    setOpenModalPoiId(null);
    setModalEditingPoiId(null);
    onCloseInfoModal();
    onCloseEditModal();
  }, [onCloseInfoModal, onCloseEditModal]);

  const handleStartEdit = useCallback(() => {
    setModalEditingPoiId(openModalPoiId);
    onOpenEditModal();
  }, [openModalPoiId, onOpenEditModal]);

  const handleStopEdit = useCallback(() => {
    setModalEditingPoiId(null);
    onCloseEditModal();
  }, [onCloseEditModal]);

  return (
    <>
      {filteredPOIs.map((poi) => {
        const isFound = foundPOIsSafe.includes(poi.id);
        const isHiddenFound = isFound && !showFound;
        const opacityValue = isHiddenFound ? 0.3 : 1;

        const shouldFlash =
          hoveredPoiId === poi.id ||
          (hoveredType === (poi.type_id ?? poi.type) && hoveredPoiId == null);

        const showThisLabel = showAllPoiLabels || (!hideSidebarHover && hoveredPoiId === poi.id);

        const categoryObj = customCategories.find(
          c => String(c.id) === String(poi.category_id ?? poi.category)
        ) || {};
        const typeObj = customTypes.find(
          t => String(t.id) === String(poi.type_id ?? poi.type)
        ) || {};

        const poiProps = {
          key: poi.id,
          poi,
          customCategories,
          customTypes,
          shouldFlash,
          mapId,
          userId: user?.id,
          mapOwnerId,
          typeColours,
          onCategoryUpdate,
          canEdit,
          showLabel: showThisLabel,
          onMouseEnter: () => setHoveredPoiId(poi.id),
          onMouseLeave: () => setHoveredPoiId(null),
          found: isFound,
          opacity: opacityValue,
          labelOpacity: opacityValue,
          iconOpacity: opacityValue,
          onToggleFound: () => onToggleFound(poi.id),
          user,
          selectedPoiId,
          setSelectedPoiId,
          hideSidebarHover,
          poiId: poi.id,
          poiName: poi.poi_name || poi.name || "",
          x: poi.x,
          y: poi.y,
          typeId: poi.type_id ?? poi.type,
          typeName: typeObj.name || "",
          typeColour: typeObj.color || poi.colour || "",
          typeShape: typeObj.shape || poi.shape || "",
          categoryId: poi.category_id ?? poi.category,
          categoryName: categoryObj.name || "",
          colour: poi.colour || typeObj.color || "",
          shape: poi.shape || typeObj.shape || "",
          description: poi.description || "",
          iconFile: poi.icon_file || "",
          imageUrl: poi.image_url || "",
          labelBorder: typeof poi.label_border !== "undefined" ? poi.label_border : 1,
          labelBgColour: poi.label_bg_colour || "#000000",
          map_id: poi.map_id,
          onOpenModal: () => handleOpenModal(poi.id),
          onCloseModal: handleCloseModal,
          onStartEdit: handleStartEdit,
          onStopEdit: handleStopEdit,
          modalOpen: openModalPoiId === poi.id,
          isEditing: modalEditingPoiId === poi.id,
        };

        return (
          <OfflinePOIMarker {...poiProps} />
        );
      })}
    </>
  );
}

export default OfflinePOILayer;
